module.exports = __webpack_public_path__ + "img/vertical_4_4_6005.050b24db.png";